<div role="alert"
     class="alert alert-danger"
     *ngIf="errorMessage">{{errorMessage}}
</div>
<div *adaptLoading="isLoading">
    <div [ngSwitch]="cardDetails">
        <div *ngSwitchCase="undefined"
             class="alert alert-warning">
            <p>Your organisation is paying by credit card, however, no credit card information has been provided.</p>
        </div>
        <div *ngSwitchDefault>
            <dd>
                <div>{{cardDetails!.brand}} ending in {{cardDetails!.last4}}</div>
                <div *ngIf="cardDetails!.name">{{cardDetails!.name}}</div>
                <div>Expiring {{cardDetails!.expiryMonth}}/{{cardDetails!.expiryYear}}</div>
            </dd>
        </div>
    </div>
    <button *ngIf="allowEditing && !isEditMode"
            adaptButton="primary"
            class="mt-4"
            [adaptBlockingClick]="showUpdateCreditCardDialog">Update payment method</button>
</div>
